export default __webpack_public_path__ + "img/536c5559eb45b0bb87b48e33234c2ed1.svg";